import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AppIcon from "ui/components/icons/AppIcon";
import { iconArrowUpward } from "ui/components/icons";
import IconButton from "@mui/material/IconButton";
import { useGlobalSearchContext } from "./SearchProvider";

const GlobalSearchSortOptions = () => {
  const { sortByCreatedDate, handleSortByCreatedDate } =
    useGlobalSearchContext();
  return (
    <Box
      sx={{
        display: "flex",
        gap: "0.8rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={handleSortByCreatedDate}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: 12,
            color: "text.primary",
            "&:hover": {
              color: "info.main",
            },
            transition: "color 0.1s ease-in",
          }}
        >
          Created Date
        </Typography>

        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleSortByCreatedDate();
          }}
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <AppIcon
            icon={iconArrowUpward}
            fontSize="small"
            sx={{
              color: "info.main",
              transform:
                sortByCreatedDate === "desc"
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              transition: "transform 0.2s ease-in",
            }}
            data-test-id="arrow-upward-icon"
          />
        </IconButton>
      </Box>
      <Divider orientation="vertical" variant="middle" flexItem />
    </Box>
  );
};

export { GlobalSearchSortOptions };
